import { ReleaseDtoRead, UserInfoDtoRead } from '@/rtkApi/mddApiSliceGeneratedV2'

import { DeploymentPackageRecord } from './types'

const ownerName = (user?: UserInfoDtoRead) => user?.fullName || user?.loginName || ''

export const mapDeploymentPackage = (dto: ReleaseDtoRead): DeploymentPackageRecord => ({
	branchId: dto.branch?.id ?? 0,
	branchName: dto.branch?.name ?? '',
	description: dto.description ?? '',
	id: String(dto.id ?? ''),
	name: dto.name,
	owner: ownerName(dto.responsibleUser),
	status: dto.status ?? 'OPEN',
})
